import { GameCommunicationMessageType, gameStateActions, IGameCommunicationProcessor, Logger } from '@pp/core';

import { RecentResultsItemType } from '../../../api/recentResults';
import { BetMapping } from '../../../config/bets';
import type { GameStore } from '../../../store/GameStore';
import { mwGameStateActions } from '../../../store/slices/mwGame/slice';
import { mwStateActions } from '../../../store/slices/mwState/slice';
import { MWSpecificGameStatus, MWGameStatus } from '../../../store/slices/mwState/types';
const LOGGER_NAME = 'GameCommunicationProcessor';

export enum ResultCode {
  Number = '1',
}

export interface GameResultMessage extends GameCommunicationMessageType {
  gameId: string;
  gameResult: string;
  multiplier: string;
  payout: string;
  sbmul: string;
  resultCode: any;
  rngSlot: string;
}
export class GameCommunicationGameResultProcessor implements IGameCommunicationProcessor {
  messageName = 'megawheelgameresult';

  process(message: GameResultMessage, store: GameStore): void {
    const parsedMessage: RecentResultsItemType = this.transformMessage(message);
    const isLoadedInActiveRound = store.getState().gameState.timer <= 0;
    const hasBets = store.getState().bets.betStack.length > 0;
    if (isLoadedInActiveRound && hasBets) {
      store.dispatch(gameStateActions.setCurrentGameStatus(MWGameStatus.SPINNING));
    }

    window.setTimeout(() => {
      store.dispatch(mwGameStateActions.prependRecentResult(parsedMessage));
      this.handleGameResult(parsedMessage, store);
      this.handleGameStatus(parsedMessage, store);
    });
  }

  private handleGameResult(parsedMessage: RecentResultsItemType, store: GameStore): void {
    const winningBetSpot = BetMapping[parsedMessage.gameResult];

    if (winningBetSpot) {
      store.dispatch(
        mwStateActions.setGameResult({
          betSpot: winningBetSpot,
          rc: parsedMessage.resultCode,
          gameResult: parsedMessage.gameResult,
          rngSlot: parsedMessage.rngSlot,
        })
      );
    } else {
      Logger.logInfo(LOGGER_NAME, 'error', `Unknown winning bet spot: ${parsedMessage.gameResult}`);
    }
  }

  private handleGameStatus(parsedMessage: RecentResultsItemType, store: GameStore) {
    const resultMapping: Record<string, MWSpecificGameStatus> = {
      '1': MWSpecificGameStatus.RESULT_1,
      '2': MWSpecificGameStatus.RESULT_2,
      '5': MWSpecificGameStatus.RESULT_5,
      '8': MWSpecificGameStatus.RESULT_8,
      '10': MWSpecificGameStatus.RESULT_10,
      '15': MWSpecificGameStatus.RESULT_15,
      '20': MWSpecificGameStatus.RESULT_20,
      '30': MWSpecificGameStatus.RESULT_30,
      '40': MWSpecificGameStatus.RESULT_40,
    };
    const resultStatus = resultMapping[parsedMessage.gameResult];
    const WinningBetSpot = BetMapping[parsedMessage.gameResult];
    const winAmount = store?.getState().mwState.winingAmount?.winingAmount;

    if (winAmount) {
      if (parsedMessage.gameResult == parsedMessage.rngSlot) {
        store.dispatch(gameStateActions.setCurrentGameStatus(MWSpecificGameStatus.MEGA_WIN));
      } else {
        store.dispatch(gameStateActions.setCurrentGameStatus(MWSpecificGameStatus.YOU_WIN));
      }
    } else {
      const { betStack } = store.getState().bets;
      const currentBets = betStack[betStack.length - 1];
      if (currentBets) {
        const isWin = !!currentBets.betSpots[WinningBetSpot]?.value;
        if (isWin && parsedMessage.gameResult === parsedMessage.rngSlot) {
          store.dispatch(gameStateActions.setCurrentGameStatus(MWSpecificGameStatus.MEGA_WIN));
        } else if (isWin) {
          store.dispatch(gameStateActions.setCurrentGameStatus(MWSpecificGameStatus.YOU_WIN));
        } else {
          store.dispatch(gameStateActions.setCurrentGameStatus(resultStatus));
        }
      } else {
        store.dispatch(gameStateActions.setCurrentGameStatus(resultStatus));
      }
    }
  }

  private transformMessage(message: any): RecentResultsItemType {
    return {
      gameId: message.id,
      gameResult: message.value,
      multiplier: message.multiplier,
      sbmul: message.multiplier,
      resultCode: message.value,
      rngSlot: message.rngSlot,
    };
  }
}
